// extracted by mini-css-extract-plugin
module.exports = {"startNewButton":"src-containers-Project-Detail-Subawards-styles___startNewButton"};